import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListValueSelectorComponent } from './list-value-selector.component';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { SearchBarModule } from '../search-bar/search-bar.module';
import { FilterPipeModule } from '../../utils/pipes/filter/filter.pipe.module';
import { DialogHeaderModule } from '../dialog-header/dialog-header.module';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [ListValueSelectorComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    DragDropModule,
    MatDividerModule,
    MatListModule,
    MatButtonModule,
    FilterPipeModule,
    FormsModule,
    SearchBarModule,
    DialogHeaderModule,
  ],
  exports: [ListValueSelectorComponent]
})
export class ListValueSelectorModule { }
